import { createdATFilter } from 'modules/common/constants';

export const termsFilters = [createdATFilter];
